import gql from 'graphql-tag';

export const UPSERT_TERRITORY_GROUP_OWNER = gql`
  mutation UpsertTerritoryGroupOwner($input: TerritoryGroupOwnerInput!) {
    upsertTerritoryGroupOwner(input: $input) {
      success
    }
  }
`;
